import React, { useEffect, useState } from "react";
import Boton from "./Boton";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

const ContainerButtons = ({ setMostrarBanner }) => {
  const [categorias, setCategorias] = useState([]);

  useEffect(() => {
    const cargarCategorias = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "categorias"));

        const docs = [];

        querySnapshot.forEach((doc) => {
          docs.push({
            id: doc.id,
            ...doc.data(),
          });
        });

        docs.sort((a, b) => (a.orden || 0) - (b.orden || 0));

        setCategorias(docs);
      } catch (error) {
        console.error("Error cargando categorías:", error);
      }
    };

    cargarCategorias();
  }, []);

  return (
    <div className="container-buttons">
      {categorias.map((categoria) => (
        <Boton
          key={categoria.id}
          data={categoria.nombre}
          nombre={`Boton${categoria.reff}`}
          imagen={categoria.imagen}
          reff={categoria.reff}
          setMostrarBanner={setMostrarBanner}
        />
      ))}
    </div>
  );
};

export default ContainerButtons;